import { Link } from "react-router-dom";
import type { CharacterItem } from "@/types";

interface CharacterCardProps {
  item: CharacterItem;
}

export default function CharacterCard({ item }: CharacterCardProps) {
  return (
    <Link
      to={`/characters/${item.id}`}
      className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
    >
      <div className="aspect-square w-full overflow-hidden bg-background-200">
        <img
          src={item.avatar}
          alt={`${item.name} 角色立绘`}
          title={`${item.name} 角色介绍 - 漫蛙2`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-3.5">
        <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-700 md:text-base">
          {item.name}
        </h3>
        <p className="mt-1 flex items-center gap-1 truncate text-xs text-foreground-500">
          <i className="ri-film-line"></i>
          {item.work}
        </p>
        <div className="mt-2.5 flex flex-wrap gap-1.5">
          {item.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}